import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Hero = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const goBookSession = () => {
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/signup', { state: { from: '/dashboard' } });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-announcement">
            <Sparkles size={14} />
            <span>Transform Your Life • Heal Your Energy • Discover Your Purpose</span>
          </div>

          <h1 className="hero-title">
            Unlock Your Full Potential Through Holistic Healing & Transformation
          </h1>

          <p className="hero-subtitle">
            Experience profound shifts with NLP Coaching, Reiki Energy Healing, 
            and Akashic Records guidance. Your journey to alignment starts here.
          </p>

          <div className="hero-cta">
            <button onClick={goBookSession} className="btn-primary btn-large" data-testid="hero-book-session-btn">
              Book Your Session
              <ArrowRight size={18} style={{ marginLeft: '0.5rem' }} />
            </button>
            <button onClick={scrollToServices} className="btn-secondary btn-large" data-testid="hero-explore-services-btn">
              Explore Services
            </button>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Lives Transformed</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-number">3</div>
              <div className="stat-label">Healing Modalities</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
